import {
  route,
} from '@app/Routing/helpers'
import { accessPermission } from '@access/permissions'

import {
  ALL,
} from '@app/Seller/accessTokens'

const OrdersBase = () => import('@app/Seller/Components/Base')
const OrdersList = () => import('@app/Seller/Orders/List')
const OrdersEdit = () => import('@app/Seller/Orders/Edit')
const OrdersAdd = () => import('@app/Seller/Orders/Add')

const MODEL = 'orders'

const BASE = `${MODEL}/`
// const u = url => BASE + url

const LIST = ''
const ADD = 'add/'
const EDIT = ':id/edit/'

export const ORDERS_PREFIX = `${MODEL}:`
const p = name => ORDERS_PREFIX + name

export const ORDERS_BASE_NAME = p('base')
export const ORDERS_LIST_NAME = p('list')
export const ORDERS_ADD_NAME = p('add')
export const ORDERS_EDIT_NAME = p('edit')

export function createRoutes(options) {
  return [
    route(BASE, OrdersBase, ORDERS_BASE_NAME, {
      meta: accessPermission(ALL, options),
      redirect: { name: ORDERS_LIST_NAME },
      children: [
        route(LIST, OrdersList, ORDERS_LIST_NAME, {
          meta: accessPermission(ALL, options),
        }),
        route(ADD, OrdersAdd, ORDERS_ADD_NAME, {
          meta: accessPermission(ALL, options),
        }),
        route(EDIT, OrdersEdit, ORDERS_EDIT_NAME, {
          meta: accessPermission(ALL, options),
        }),
      ],
    }),
  ]
}
